<template>

	<div class="container">
		<b-loading v-model="isLoading"></b-loading>
		<div v-if="!isLoading && portfolio != null">
			<h1 class="has-text-centered">{{ portfolio.Name }} Portfolio &nbsp;&nbsp;<span class="has-pointer" @click="savePortfolio"><b-icon icon="pencil"></b-icon></span></h1>
			<div class="level">
				<div class="level-left">
					<b-input type="text" expanded icon="search" placeholder="search" v-model="filter"></b-input>
				</div>
				<div class="level-right">
					<div class="level-item">
						<b-button icon-left="chart-pie-alt" class="is-default" @click="viewReport">View report</b-button>
					</div>
					<div class="level-item">
						<b-button icon-left="download" class="is-default"><download-csv :data="aircraftCSV" :fields="['Name', 'Manufacturer', 'Aircraft model', 'AircraftType', 'Quantity', 'Average flight hours', 'Average Cycles', 'Aggregate Annual C02 emissions (tonnes)']" :name="$moment().format('DD-MM-YYYY') + '-' + portfolio.Name + '.csv'">Download CSV</download-csv></b-button>
					</div>
					<div class="level-item">
						<b-button icon-left="plane" class="is-primary" @click="addAircraft">Add aircraft to portfolio</b-button>
					</div>
				</div>
			</div>
			<AircraftTable :Aircraft="filteredAircraft"
						   RemovedLevel
						   Name
						   Model
						   Manage
						   Download
						   ConfirmDelete="Remove aircraft from this portfolio?"
						   :OnDelete="removeAircraft"
						   @afterDelete="afterRemoveAircraft($event)"
						   @refreshManage="getPortfolioWithAircraft()"></AircraftTable>
		</div>
	</div>

</template>

<script>

	import AircraftTable from "@/components/aircraft/aircraftTable.vue";
	import AddAircraft from "@/components/modals/addAircraft/addAircraft.vue";
	import SavePortfolio from "@/components/modals/savePortfolio.vue";
	import CreateNew from "@/components/modals/addAircraft/createNew.vue";
	import ExistingPortfolio from "@/components/modals/addAircraft/fromExistingPortfolio.vue";
	import ExistingAircraft from "@/components/modals/addAircraft/existingAircraft.vue";
	export default {
		components: {
			AircraftTable
		},
		props: {
			PortfolioId: String
		},
		data() {
			return {
				portfolio: {},
				aircraft: [],
				isLoading: false,
				filter: ''
			}
		},
		mounted() {
			this.getPortfolioWithAircraft();
		},
		computed: {
			filteredAircraft() {
				return this.aircraft.filter((option) => {
					if (option.Name.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.Name
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					} else if (option.ModelName.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.ModelName
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					} else if (option.Quantity.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.Quantity
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					} else if (option.FlightHours.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.FlightHours
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					} else if (option.Cycles.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.Cycles
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					} else if (option.CarbonOutput.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
						return option
							.CarbonOutput
							.toString()
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) >= 0;
					}
				});
			},
			aircraftCSV() {
				if (this.aircraft)
					return this.aircraft.map(a => ({
						'Name': a.Name,
						'Aircraft model': a.ModelName,
						'Quantity': a.Quantity,
						'Average flight hours': a.FlightHours,
						'Average Cycles': a.Cycles,
						'Aggregate Annual C02 emissions (tonnes)': a.CarbonOutput,
						'Manufacturer': a.Manufacturer,
						'Aircraft Type': a.AircraftType
					}))
				else
					return null;
			}
		},
		methods: {
			viewReport() {
				this.$router.push({ name: "PortfolioReport", params: { PortfolioId: this.PortfolioId } });
			},
			downloadCSV() {
				let csvContent = "data:text/csv;charset=utf-8,"
					+ this.aircraft.map(e => JSON.stringify(e)).join("\n");
				var encodedUri = encodeURI(csvContent);
				var link = document.createElement("a");
				link.setAttribute("href", encodedUri);
				link.setAttribute("download", this.portfolio.Name + ".csv");
				document.body.appendChild(link); // Required for FF

				link.click()
			},
			removeAircraft(Id) {
				return this.$http.get("api/aircraft/remove/" + Id + "/" + this.PortfolioId);
			},
			afterRemoveAircraft(i) {
				if (i > -1) {
					this.aircraft.splice(i, 1);
					this.$buefy.toast.open({
						message: "Successfully removed aircraft.",
						type: 'is-success'
					});
				}
				else {
					this.$buefy.toast.open({
						message: "Failed to remove aircraft.",
						type: 'is-danger'
					});
				}
			},
			updateAircraftTable(result) {
				if (result.index > -1) {
					this.$set(this.aircraft, result.index, result.aircraft);
				}
				else {
					this.aircraft.push(result.aircraft);
				}
			},
			getPortfolioWithAircraft() {
				this.isLoading = true;
				this.$http.get("api/portfolio/" + this.PortfolioId + "/aircraft")
					.then(resp => {
						this.portfolio = {};
						this.aircraft = [];
						this.$set(this, 'portfolio', resp.data.Portfolio);
						this.$set(this, 'aircraft', resp.data.Aircraft);
						this.isLoading = false;
					})
			},
			addAircraft() {
				this.$buefy.modal.open({
					parent: this,
					component: AddAircraft,
					hasModalCard: true,
					events: {
						'existing': () => {
							this.existingAircraft();
						},
						'fromPortfolio': () => {
							this.fromPortfolio();
						},
						'createNew': () => {
							this.createNew();
						}
					}
				})
			},
			existingAircraft() {
				this.$buefy.modal.open({
					parent: this,
					component: ExistingAircraft,
					hasModalCard: true,
					props: {
						PortfolioId: this.PortfolioId
					},
					events: {
						'close': async () => {
							await this.$http.get("/api/portfolio/" + this.PortfolioId + "/cache");
							this.getPortfolioWithAircraft();
						}
					}
				})
			},
			fromPortfolio() {
				this.$buefy.modal.open({
					parent: this,
					component: ExistingPortfolio,
					hasModalCard: true,
					props: {
						PortfolioId: this.PortfolioId
					},
					events: {
						'close': async () => {
							await this.$http.get("/api/portfolio/" + this.PortfolioId + "/cache");
							this.getPortfolioWithAircraft();
						}
					}
				})
			},
			createNew() {
				this.$buefy.modal.open({
					parent: this,
					component: CreateNew,
					hasModalCard: true,
					props: {
						PortfolioId: this.PortfolioId
					},
					events: {
						'refreshAircraft': async () => {
							await this.$http.get("/api/portfolio/" + this.PortfolioId + "/cache");
							this.getPortfolioWithAircraft();
						},
						'createNew': async () => {
							await this.$http.get("/api/portfolio/" + this.PortfolioId + "/cache");
							this.getPortfolioWithAircraft();
							this.createNew();
						}
					}
				})
			},
			savePortfolio() {
				this.$buefy.modal.open({
					parent: this,
					component: SavePortfolio,
					hasModalCard: true,
					props: {
						Portfolio: this.portfolio
					},
					events: {
						refreshPortfolio: async (portfolio) => {
							this.portfolio.Name = portfolio.Name;
						}
					}
				})
			}
		}
	}
</script>
